<div role="cell" class="tw-flex tw-gap-2 tw-items-center tw-min-w-0 tw-px-4 tw-py-2">
  <ng-content select="[slot=start]"></ng-content>

  <div class="tw-flex tw-flex-col tw-min-w-0 tw-flex-grow">
    <div [class]="contentClasses()">
      <ng-content></ng-content>
    </div>
    <div
      bitTypography="helper"
      class="tw-text-fg-body-subtle empty:tw-hidden"
      [class]="contentClasses()"
    >
      <ng-content select="[slot=secondary]"></ng-content>
    </div>
  </div>

  <div
    class="tw-flex tw-items-center empty:tw-hidden"
    [class.tw-gap-2]="!isItemEndSlot()"
    [attr.data-bit-item-end-slot]="isItemEndSlot() ? '' : null"
  >
    <ng-content select="[slot=end]"></ng-content>
  </div>
</div>
